import find from 'lodash/find'
import { FieldOption } from './accountTypes'

const postTypes: FieldOption[] = [
  { value: 'news', name: 'News' },
  { value: 'monday_motivator', name: 'Monday Motivator' }
]

export default postTypes

export function typeName (value: string): string | null {
  const option = find(postTypes, { value })
  return option ? option.name : null
}
